module.exports = __webpack_public_path__ + "static/media/pl.1f9d98ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/pl.svg
// module id = 224
// module chunks = 0